const {
  REACT_APP_GOOGLE_API_KEY: GOOGLE_API_KEY,
  REACT_APP_STRIPE_PUBLIC_KEY: STRIPE_PUBLIC_KEY,
} = process.env as Record<string, string>;

export { GOOGLE_API_KEY, STRIPE_PUBLIC_KEY };
